import { render } from "./UserListMenuDeve.vue?vue&type=template&id=1cd487c4&scoped=true"
import script from "./UserListMenuDeve.vue?vue&type=script&lang=js"
export * from "./UserListMenuDeve.vue?vue&type=script&lang=js"

import "./UserListMenuDeve.vue?vue&type=style&index=0&id=1cd487c4&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd487c4"]])

export default __exports__